import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./Requirement.module.css";
import { customTextColor } from "../../utils/const";
import { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { HiOutlineMailOpen } from "react-icons/hi";
import { IoIosSearch } from "react-icons/io";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiLinkedinLogoLight } from "react-icons/pi";
//   import SideIcon from "./SideIcon";
import { BsThreeDotsVertical } from "react-icons/bs";
import Search from "../../assets/images/search (2).png";
import { BsFileEarmarkText } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import profile_image from "../../assets/images/ajit_image.jpeg";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
const MoreViewDetails = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const [oppen, setOppen] = useState(false);
  const [side, setSide] = useState(false);

  const handleCloseSide = () => setSide(false);
  const handleSide = () => setSide(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isProfileVisible, setIsProfileVisible] = useState(false);

  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const [typeResult, setTypeResult] = useState("public");
  const navigate = useNavigate();
  return (
    // <RootComponents>
      <>
      <Box className={styles.search_candidate_stucture}>
        <Grid container className={styles.verification_phase}>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{ color: customTextColor, border: "none !important" }}
          >
            <Typography sx={{ marginLeft: "0 !important" }}>
              <HiOutlineMailOpen
                style={{
                  fontSize: "25px",
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                  padding: "2px 0px 2px 0px",
                }}
              />
              <Box component="span" sx={{ marginLeft: "10px" }}>
                Category:<b> Important </b>
              </Box>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{ color: customTextColor }}
          >
            <Typography>
              <HiOutlineMailOpen
                style={{
                  fontSize: "25px",
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                  padding: "2px 0px 2px 0px",
                }}
              />
              <Box component="span" sx={{ marginLeft: "10px" }}>
                Date: <b> 17 May 2024 </b>
              </Box>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{ color: customTextColor }}
          >
            <Typography sx={{ cursor: "pointer" }}>
              <HiOutlineMailOpen
                style={{
                  fontSize: "25px",
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                  padding: "2px 0px 2px 0px",
                }}
              />
              <Box component="span" sx={{ marginLeft: "10px" }}>
                Time: <b>10:37 PM 12 Min Ago</b>
              </Box>
            </Typography>
            <BsThreeDotsVertical
              onClick={handleThreeDotsClick}
              style={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid>

        <Box className={styles.profile_and_submit}>
          <Box>
            <Typography sx={{ fontSize: "18px !important" }}>
              <b>
                ID: 742001 Remote Hot Senior Python Job Opening in USA 743012
              </b>
            </Typography>
            <Grid container className={styles.verification_phase}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ color: customTextColor, border: "none !important" }}
              >
                <Typography sx={{ marginLeft: "0 !important" }}>
                  <HiOutlineMailOpen
                    style={{
                      fontSize: "25px",
                      backgroundColor: "#e1eaf0",
                      cursor: "pointer",
                      borderRadius: "3px ",
                      padding: "2px 0px 2px 0px",
                    }}
                  />
                  <Box component="span" sx={{ marginLeft: "10px" }}>
                    Job Title:<b> Lead Java Developer </b>
                  </Box>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ color: customTextColor }}
              >
                <Typography>
                  <HiOutlineMailOpen
                    style={{
                      fontSize: "25px",
                      backgroundColor: "#e1eaf0",
                      cursor: "pointer",
                      borderRadius: "3px ",
                      padding: "2px 0px 2px 0px",
                    }}
                  />
                  <Box component="span" sx={{ marginLeft: "10px" }}>
                    Required: <b> 12 Years </b>
                  </Box>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ color: customTextColor }}
              >
                <Typography sx={{ cursor: "pointer" }}>
                  <HiOutlineMailOpen
                    style={{
                      fontSize: "25px",
                      backgroundColor: "#e1eaf0",
                      cursor: "pointer",
                      borderRadius: "3px ",
                      padding: "2px 0px 2px 0px",
                    }}
                  />
                  <Box component="span" sx={{ marginLeft: "10px" }}>
                    Location: <b>: Dallas Taxes, TX</b>
                  </Box>
                </Typography>
              </Grid>
            </Grid>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                <Typography sx={{ marginTop: "10px !important" }}>
                  Mode of Hiring: <b>12 Months Contract </b>
                </Typography>
                <Typography>
                  Visa Applicable:{" "}
                  <b> Green Card, GC EAD, US Citizen, H4EAD </b>
                </Typography>
                <Typography>
                  Mode of Interview:
                  <b>Virtual</b>
                </Typography>
                <Typography>
                  Client:
                  <b> Not Disclosed </b>
                </Typography>
                <Typography>
                  Pay Rate:
                  <b>$70 Hourly</b>
                </Typography>
              </span>

              <span
                className={styles.phase2}
                style={{ marginTop: "20px !important", alignSelf: "end" }}
              >
                <Typography
                  sx={{
                    fontSize: "50px !important",
                    fontWeight: "600",
                    marginBottom: "0 !important",
                  }}
                >
                  05
                </Typography>
                <Typography>
                  <b>No of Job Opening</b>
                </Typography>
              </span>
            </span>
          </Box>
        </Box>

        <Box className={styles.candidate_text} sx={{ marginBottom: "14px" }}>
          {" "}
          <span>
            <Typography sx={{ color: "customTextColor" }}>
              <b>Job Description</b>
            </Typography>
            <Typography>
              SAFe Project Manager & Scrum Master with extensive experience in
              Scaled Agile Framework (SAFe) to manage and oversee complex
              projects within our Agile release Trains. Candidate should have
              stron background in IT project management coupled with deep
              knowledge of the Scaled Agile Framework( SAFe). This position
              requires a unique blend of technical project management expertise,
              agile methodologies, and a deep understanding of employee needs.
              We believe that empowered and engaged employees drive innovation
              and success. Our team is passionate about creating intuitive,
              user-friendly solutions that streamline workflows, foster
              collaboration, and enhance productivity
            </Typography>
            <Typography sx={{ color: "customTextColor" }}>
              <b>Mandatory Skills</b>
            </Typography>
            <Typography>
              Certifications: Project Management Professional (PMP), Certified
              Scrum Master (CSM), or similar certifications. SAFe Agilist (SA)
              or SAFe practitioner certification
              <div>
                Technical Background: Experience with software development or IT
                infrastructure
              </div>
            </Typography>
          </span>
        </Box>

        <div style={{ backgroundColor: "#fff", padding: "5px 10px 5px 10px" }}>
          <Box className={styles.recruiter_profile}>
            <div>
              <img src={profile_image} alt="" />
              <span style={{ color: customTextColor }}>
                <Typography>
                  <b> Mohan Mishra </b>
                </Typography>
                <Typography>
                  <b>Senior TI Recruiter at Tech Solutions Pvt Ltd</b>
                </Typography>
                <Typography sx={{ marginBottom: "10px !important" }}>
                  Website: www.techsolution.com | Linkedin:
                  mohan-itrecruiter/linkedin.com
                </Typography>
                <Typography sx={{ marginBottom: "5px !important" }}>
                  <Box>
                    <Typography>
                      <span
                        style={{
                          backgroundColor: "#e1eaf0",
                          borderRadius: "3px",
                          padding: "5.5px",
                        }}
                      >
                        <PiFileTextLight style={{ fontSize: "20px" }} />
                      </span>
                      <b style={{ marginLeft: "10px" }}>
                        E-Mail ID:Mishra@techsolutions.com
                      </b>
                    </Typography>

                    <Typography sx={{ marginLeft: "10px" }}>
                      <span
                        style={{
                          backgroundColor: "#e1eaf0",
                          borderRadius: "3px",
                          padding: "5.5px",
                        }}
                      >
                        <PiFilesLight style={{ fontSize: "22px" }} />
                      </span>
                      <b style={{ marginLeft: "10px" }}>
                        Phone No: 2427-447-0021
                      </b>
                    </Typography>
                  </Box>
                </Typography>
              </span>
            </div>
          </Box>
        </div>
      </Box>

      <Box className={styles.internal_update_btns}>
        <Box className={styles.back_btns}>
          <button
            style={{
              backgroundColor: "#3856a6",
              padding: "7.5px 20px ",
            }}
            onClick={() => navigate("/requirement-apply-view")}
          >
            Apply
          </button>
          {/* <span className={styles.add_btns}>
            <button
              style={{
                backgroundColor: "#4285f4",
                padding: "7.5px 10px ",
                marginLeft: "10px",
              }}
              onClick={() => navigate("/requirement-ask-view")}
            >
              Ask More
            </button>
          </span> */}
        </Box>
        <Box>
          <button
            style={{
              backgroundColor: "#f2f2f2 ",
              padding: "7.5px 10px ",
              border: "1.5px solid #beb5b5",
              color: "black",
            }}
          >
            Skip & Next
          </button>
        </Box>
      </Box>
      </>
    // </RootComponents>
  );
};

export default MoreViewDetails;
